import { useEffect } from 'react'
import {getListIncrements} from '../../../services/sPay/increment.service'


const useGetIncrementsMaintainer = (mantainerList, setMantainer) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListIncrements();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({id: element.id , name: element.name, order: element.order})
                });

                setMantainer(aux_array);
            }
            catch (error) {
                setMantainer([])
            }
        }
        
        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

export {
    useGetIncrementsMaintainer}